import React from 'react';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import CommissionLineSearchParams from './CommissionLineSearchParams';
import CommissionLineService from '../../../Services/CommissionLineService';
import CommissionLineItem from '../../../Domain/CommissionLineItem';

export default class CommissionLineAdmin extends React.Component {
  static defaultProps = {
    changeTab: (index) => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      searchItem: new CommissionLineSearchParams(),
    };

    this.startSearch = this.startSearch.bind(this);
    CommissionLineItem.changeTab = this.changeTab.bind(this);
  }

  startSearch(searchItem) {
    this.setState({ searchItem: { ...searchItem } });
  }

  changeTab(item) {
    this.props.changeTab(
      1,
      item.CommissionedUserId,
      item.CommissionedExternalSalesPartnerId,
      item.ClientId,
      item.OpportunityId,
      item.ServiceId
    );
  }

  render() {
    return (
      <div className='contentwrapper'>
        <TabOfDataTable
          type={CommissionLineItem}
          serviceFunction={CommissionLineService.GetListBySearching}
          convertDBItemsFunction={CommissionLineService.ConvertDBItems}
          searchParamsType={CommissionLineSearchParams}
          showSearchStrip={true}
          clickOnStartSearch={this.startSearch}
          searchItem={this.state.searchItem}
          orderBy='ServiceId'
          orderDirection='Desc'
          errorCode='CLA43'
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in various fields...'
        />
      </div>
    );
  }
}
